import type { Quantity } from '~/graphql/graphql';
import type { SummaryProduct } from '~/pages/buy-lists/sections/SummaryProductsPanel';
import type { BuyListDetailItem } from '~/pages/buy-lists/sections/types';
import type { BuyListDetailTally } from '~/pages/buy-lists/sections/tallies/types';
import { useTallyLabel } from '~/pages/buy-lists/sections/tallies/useTallyLabel';
import {
  toSummaryProduct,
  toTallySummaryProduct,
} from '~/pages/buy-lists/sections/toSummaryProduct';

type SummarySelection = {
  selectedItems: BuyListDetailItem[];
  quantityFor: (item: BuyListDetailItem) => Quantity;
  selectedTallies: BuyListDetailTally[];
  tallyCountFor: (tally: BuyListDetailTally) => number | null;
};

export function useSummaryProducts({
  selectedItems,
  quantityFor,
  selectedTallies,
  tallyCountFor,
}: SummarySelection): SummaryProduct[] {
  const tallyLabel = useTallyLabel();
  return [
    ...selectedItems.map((item) => toSummaryProduct(item, quantityFor(item))),
    ...selectedTallies.map((tally) => {
      const tallyCount = tallyCountFor(tally);
      return toTallySummaryProduct(
        tally,
        tallyCount,
        tallyLabel(tally, tallyCount)
      );
    }),
  ];
}
